<template>
  <div class="fangdai"
       style="background: rgb(249 249 249);height: 100%;padding: 10px;">
    <!-- <van-nav-bar title="查询记录"
                 left-text="返回"
                 left-arrow
                 @click-left="$router.go(-1)"
                 :border="true"
                 :fixed="false" /> -->
    <van-cell-group inset
                    v-for="(item,i) in list"
                    :key="i"
                    style="width: 100%; margin-left: 0%; margin-bottom: 10px;">

      <van-cell title="房产信息"
                :value="item.areaName+'-'+item.villageName"
                :label="item.detailAddress"
                is-link />
      <van-cell title="产权面积"
                :value="item.cqmj" />
      <van-cell title="房产类型"
                :value="item.tdjb+'-'+item.fclx" />
      <van-cell title="评估总价"
                :value="item.unitPrice+'元'" />
      <van-cell title="评估总价"
                :value="item.totalPrice+'元'" />
      <div style="text-align: right; margin-top: -10px; padding-bottom: 10px; margin-right: 10px;">

        <van-button type="warning"
                    size="mini"
                    :to="'/result?total='+item.totalPrice+'&unit='+item.unitPrice ">查看结果</van-button>

        <van-button type="primary"
                    color="#48A26A "
                    size="mini"
                    :to="'/house?id='+item.recordId ">重新评估</van-button>
      </div>
    </van-cell-group>
    <van-empty v-if="list.length<=0"
               description="暂无待查询记录" />
    <div style="height:60px"></div>
  </div>

</template>

<script>
import { getQueryList } from '@/api/public'

export default {
  name: 'user',
  data () {
    return {
      list: []
    };
  },
  created () {
    this.$store.state.tabBar = this.$route.name;
    this.getUserQueryInfos();
  },
  methods: {

    getUserQueryInfos () {
      getQueryList().then((res) => {
        this.list = res.data;
      }).catch(e => {
        console.log(e);
      })
    },
    cellClick (index) {
      this.list.forEach((item, i) => {
        if (i == index) {
          this.list[index].active = !this.list[index].active;
        } else {
          item.active = false;
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
html {
  height: 100% !important;
}
#app {
  height: 100%;
  background: #f7fafa !important;
}
.van-cell {
  padding: 0.13667rem 0.42667rem !important;
  font-size: 0.27333rem !important;
}
</style>

